import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useWhatsAppStatus(pollMs = 10000) {
  const { user } = useAuth();
  const [status, setStatus] = useState("disconnected");

  const fetchStatus = useCallback(async () => {
    if (!user || !user.id) return;
    try {
      const { data } = await api.get("/whatsapp/status");
      setStatus(data.status || "disconnected");
    } catch (_) {
      setStatus("disconnected");
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchStatus();
    const t = setInterval(fetchStatus, pollMs);
    return () => clearInterval(t);
  }, [user, fetchStatus, pollMs]);

  return { status, refresh: fetchStatus };
}
